import { render, staticRenderFns } from "./BillGivePoints.vue?vue&type=template&id=ec403b8e&scoped=true&"
import script from "./BillGivePoints.vue?vue&type=script&lang=js&"
export * from "./BillGivePoints.vue?vue&type=script&lang=js&"
import style0 from "./BillGivePoints.vue?vue&type=style&index=0&id=ec403b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec403b8e",
  null
  
)

export default component.exports